(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/components/cart-bottom-sheets.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/components/cart-bottom-sheets.js');
"use strict";


const CartBottomSheet = svs.ticketsOrderHome.components.CartBottomSheet;
const useOrderHomeContext = svs.ticketsOrderHome.context.useOrderHomeContext;
const Button = svs.ui.ReactButton;
const formatCurrency = svs.utils.format.Currency;
const CartBottomSheetContinueSubmit = _ref => {
  let disabled = _ref.disabled,
    formId = _ref.formId;
  const _useOrderHomeContext = useOrderHomeContext(),
    state = _useOrderHomeContext.state,
    incrementOrderCount = _useOrderHomeContext.incrementOrderCount,
    decrementOrderCount = _useOrderHomeContext.decrementOrderCount;
  const _state$cart = state.cart,
    tickets = _state$cart.tickets,
    totalOrderCount = _state$cart.totalOrderCount,
    totalOrderPrice = _state$cart.totalOrderPrice,
    shippingCost = _state$cart.shippingCost,
    minimumTotalOrderPriceNotReached = _state$cart.minimumTotalOrderPriceNotReached;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    form: formId,
    inverted: true,
    type: "submit"
  }, "Forts\xE4tt"), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
const CartBottomSheetContinue = _ref2 => {
  let onContinue = _ref2.onContinue,
    disabled = _ref2.disabled;
  const _useOrderHomeContext2 = useOrderHomeContext(),
    state = _useOrderHomeContext2.state,
    incrementOrderCount = _useOrderHomeContext2.incrementOrderCount,
    decrementOrderCount = _useOrderHomeContext2.decrementOrderCount;
  const _state$cart2 = state.cart,
    tickets = _state$cart2.tickets,
    totalOrderCount = _state$cart2.totalOrderCount,
    totalOrderPrice = _state$cart2.totalOrderPrice,
    shippingCost = _state$cart2.shippingCost,
    minimumTotalOrderPriceNotReached = _state$cart2.minimumTotalOrderPriceNotReached;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    inverted: true,
    onClick: onContinue
  }, "Forts\xE4tt"), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
const CartBottomSheetPay = _ref3 => {
  let onPay = _ref3.onPay,
    disabled = _ref3.disabled;
  const _useOrderHomeContext3 = useOrderHomeContext(),
    state = _useOrderHomeContext3.state,
    incrementOrderCount = _useOrderHomeContext3.incrementOrderCount,
    decrementOrderCount = _useOrderHomeContext3.decrementOrderCount;
  const _state$cart3 = state.cart,
    tickets = _state$cart3.tickets,
    totalOrderCount = _state$cart3.totalOrderCount,
    totalOrderPrice = _state$cart3.totalOrderPrice,
    shippingCost = _state$cart3.shippingCost,
    minimumTotalOrderPriceNotReached = _state$cart3.minimumTotalOrderPriceNotReached;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    focus: true,
    onClick: onPay
  }, "Betala ".concat(formatCurrency(totalOrderPrice), " kr")), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
const CartBottomSheetDynamicAction = _ref4 => {
  let onContinue = _ref4.onContinue,
    onPay = _ref4.onPay,
    disabled = _ref4.disabled,
    readyToPay = _ref4.readyToPay;
  const _useOrderHomeContext4 = useOrderHomeContext(),
    state = _useOrderHomeContext4.state,
    incrementOrderCount = _useOrderHomeContext4.incrementOrderCount,
    decrementOrderCount = _useOrderHomeContext4.decrementOrderCount;
  const _state$cart4 = state.cart,
    tickets = _state$cart4.tickets,
    totalOrderCount = _state$cart4.totalOrderCount,
    totalOrderPrice = _state$cart4.totalOrderPrice,
    shippingCost = _state$cart4.shippingCost,
    minimumTotalOrderPriceNotReached = _state$cart4.minimumTotalOrderPriceNotReached;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, readyToPay ? React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    focus: true,
    onClick: onPay
  }, "Betala ".concat(formatCurrency(totalOrderPrice), " kr")) : React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    inverted: true,
    onClick: onContinue
  }, "Forts\xE4tt"), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetContinueSubmit', CartBottomSheetContinueSubmit);
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetContinue', CartBottomSheetContinue);
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetPay', CartBottomSheetPay);
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetDynamicAction', CartBottomSheetDynamicAction);

 })(window);